import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=7a937a68&scoped=true"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=7a937a68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a937a68",
  null
  
)

export default component.exports